// RBAC — single source of truth for frontend.
// Mirrors /app/backend/rbac.py.

export const ROLES = [
  "viewer", "teacher", "principal", "trainer", "coordinator", "org_admin", "super_admin",
];

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  org_admin: "Organization Admin",
  coordinator: "Coordinator",
  trainer: "Trainer",
  principal: "Principal",
  teacher: "Teacher",
  viewer: "Viewer",
};

const ALIASES = { admin: "super_admin", school: "principal" };
export const normalizeRole = (r) => ALIASES[r] || r || "viewer";

const ALL = new Set([
  "dashboard:view",
  "programs:read", "programs:write",
  "schools:read", "schools:write",
  "teachers:read", "teachers:write",
  "bookings:read", "bookings:write", "bookings:create",
  "certificates:read", "certificates:write",
  "gallery:read", "gallery:write",
  "cms:read", "cms:write",
  "settings:manage",
  "podcast:read", "podcast:write",
  "experts:read", "experts:write",
  "users:read", "users:write", "roles:assign",
  "reports:view",
]);

const withoutUserWrite = new Set([...ALL]);
withoutUserWrite.delete("users:write");
withoutUserWrite.delete("roles:assign");

export const ROLE_PERMISSIONS = {
  super_admin: ALL,
  org_admin: withoutUserWrite,
  coordinator: new Set([
    "dashboard:view", "programs:read", "schools:read", "teachers:read",
    "teachers:write", "bookings:read", "bookings:write", "bookings:create",
    "certificates:read", "gallery:read", "gallery:write", "cms:read",
    "podcast:read", "reports:view",
  ]),
  trainer: new Set([
    "dashboard:view", "programs:read", "teachers:read", "bookings:read",
    "certificates:read", "certificates:write", "gallery:read", "cms:read",
    "podcast:read",
  ]),
  principal: new Set([
    "dashboard:view", "programs:read", "schools:read", "teachers:read",
    "teachers:write", "bookings:read", "bookings:create", "certificates:read",
    "gallery:read", "cms:read", "podcast:read",
  ]),
  teacher: new Set([
    "dashboard:view", "programs:read", "certificates:read", "gallery:read",
    "cms:read", "podcast:read",
  ]),
  viewer: new Set([
    "dashboard:view", "programs:read", "schools:read", "teachers:read",
    "bookings:read", "certificates:read", "gallery:read", "cms:read",
    "podcast:read", "reports:view",
  ]),
};

export function roleCan(role, permission) {
  const perms = ROLE_PERMISSIONS[normalizeRole(role)];
  return !!perms && perms.has(permission);
}

export function userCan(user, permission) {
  if (!user) return false;
  return roleCan(user.role, permission);
}

export function userPermissions(user) {
  const perms = ROLE_PERMISSIONS[normalizeRole(user?.role)];
  return perms ? Array.from(perms).sort() : [];
}
